import { tooltipMapa, getColorMapaCalorPorcentaje } from '../utils/index';
import {
  borderWidth,
  color,
  emphasis,
  opacity,
  shadowColor,
} from '../utils/estilosMapa';
import { getNomenclatorColorsByElecCode } from '../utils/nomenclatorUtils';
import hash from 'object-hash';

function getData(rawData, nDep, amb, nomenclator, mapOpt, mapData, eleccion) {
  // old multi-chamber behavior
  /* const mapaData = camaraSeleccionada.mapagan
    ? camaraSeleccionada.mapagan
    : camaraSeleccionada.mapacam; */

  // Comprobar que hay que pintar mapa de calor (visual map)
  if (mapData) {
    let flagVM = false;
    for (let i = 1; i < mapData.length; i++) {
      if (
        mapData.length > 1 &&
        mapData[i][mapOpt.field] !== mapData[i - 1][mapOpt.field]
      ) {
        flagVM = true;
        break;
      }
    }

    // Meter datos de calor a los ambitos
    const data = mapData.map(({ act: el }, i) => {
      const value = mapOpt.valueFormatter(el);
      const sinVotos = value === 0;
      const esMuniOComu = amb.length > 4;
      const elAmbito = el.amb;
      const ambNoSeleccionado =elAmbito !== amb;
      const elecColor = getNomenclatorColorsByElecCode(nomenclator, eleccion)
        ?.cs;
      const calor = getColorMapaCalorPorcentaje(mapOpt, value.value, elecColor);
      return {
        name: el.amb,
        value: value,
        data: { sinInfo: el.mesesc === '0' },
        sinInformacion: el.mesesc === '0',
        label: { show: false },
        itemStyle: {
          color: color(sinVotos, false, calor),
          opacity: opacity(sinVotos, ambNoSeleccionado, esMuniOComu),
          borderColor:
            '#fff' /* borderColor(sinVotos, ambNoSeleccionado, esMuniOComu) */,
          borderWidth: borderWidth(ambNoSeleccionado, esMuniOComu),
          shadowColor: shadowColor(sinVotos, !ambNoSeleccionado),
          shadowBlur: !ambNoSeleccionado ? 15 : 0,
          emphasis: emphasis(sinVotos, calor),
        },
        key: i,
      };
    });

    // Meter datos sin informacion
    //data = pushAmbitosNoCelebrados(data, nDep, nomenclator, eleccion);

    return { data, flagVM };
  }
}

// Propiedades visual map
const getCalor = (rawData, nDep, mapOpt, mapData, isDesktop) => {
  // old multi-chamber behavior
  /* const mapaData = camaraSeleccionada.mapagan
    ? camaraSeleccionada.mapagan
    : camaraSeleccionada.mapacam; */
  if (mapData) {
    const hayInfo = mapData.some(({ act: el }) => el.mesesc !== '0');
    //Calcular maximo y minimo para ajustar a estos valores el mapa de calor
    const maxValue = Number(
      Math.max.apply(
        Math,
        mapData.map(({ act: el }) =>
          Number(el[mapOpt.field].replace(/,/g, '.').slice(0, -1))
        )
      )
    );
    const minValue = Math.min.apply(
      Math,
      mapData.map(({ act: el }) =>
        Number(el[mapOpt.field].replace(/,/g, '.').slice(0, -1))
      )
    );

    let text = [Math.ceil(maxValue), Math.floor(minValue)];
    let type = 'continuous';
    let min, max;
    if (minValue === maxValue) {
      const dato = isNaN(minValue)
        ? minValue
        : minValue !== 0 || hayInfo
        ? minValue + '%'
        : 'Sin información';
      text = minValue == 0 ? [dato] : [minValue + '%'];
      type = 'piecewise';
      min = minValue;
      max = maxValue;
    } else {
      min = Math.floor(minValue);
      max = Math.ceil(maxValue);
    }

    // características Visual Map
    const obj = {
      type: type,
      min: min,
      max: max,
      text: text,
      textGap: 2,
      orient: 'horizontal',
      left: '5%',
      bottom: 0,
      itemWidth: 10,
      inRange: {
        color: [
          ...new Set(getColorMapaCalorPorcentaje(mapOpt, minValue, maxValue)),
        ],
      },
      textStyle: {
        fontFamily: ['Lato', 'Open Sans'],
      },
      seriesIndex: 0,
      formatter: function(value) {
        return value === 0 || value === 100
          ? value
          : value.toFixed(2).replace(/\./g, ',');
      },
    };
    return obj;
  }
};

function getOptionCalor(
  _rawData,
  nDep,
  amb,
  nomenclator,
  mapOpt,
  stateRef,
  isDesktop,
  isMobile,
  mapFeatures,
  mapData,
  eleccion,
  setTooltipProps
) {
  const _mapData = getData(
    _rawData,
    nDep,
    amb,
    nomenclator,
    mapOpt,
    mapData,
    eleccion
  );
  const option = {
    baseOption: {
      series: [
        {
          roam: false,
          zoom: 1,
          itemStyle: {
            areaColor: '#fff',
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            boderColor: '#000',
            shadowBlur: 5,
            emphasis: { areaColor: null, borderColor: '#fff' },
          },
          right: 'auto',
          data: _mapData.data,
        },
      ],
      animation: false,
      tooltip: tooltipMapa(stateRef, isDesktop, setTooltipProps),
    },
    _id: hash(_mapData, { ignoreUnknown: true }),
  };

  if (_mapData.flagVM) {
    option.baseOption.visualMap = getCalor(
      _rawData,
      nDep,
      mapOpt,
      mapData,
      isDesktop
    );
    if (isMobile) {
      option.baseOption.visualMap.itemHeight = 18;
      option.baseOption.visualMap.itemWidth = 12;
    }
  }

  return option;
}

export { getOptionCalor };
